import secureApi from "../services/secureApi";

export const addProductVariation = async (
  variationData,
) => {
  try {
    const response =
      await secureApi.post(
        "/admin/products/addVariations",
        variationData,
      );

    return response.data;
  } catch (error) {
    console.error(
      "ADD PRODUCT VARIATION ERROR:",
      error,
    );

    throw error;
  }
};